import { styled } from '@mui/material';
import BadgeStatus from 'src/components/badge-status/BadgeStatus';
import { CustomAvatar } from 'src/components/custom-avatar';
import { CPAvatarProps, avatarSizes } from './avatarSizes';

const BadgeContainer = styled('div')(() => ({
  borderRadius: '50%',
}));

export const CPAvatar = ({
  name,
  picture,
  status,
  size = 'medium',
  mask,
  ...rest
}: CPAvatarProps) => {
  const { clipPath, ...sx } = avatarSizes[size];

  return (
    <CustomAvatar
      alt={name}
      src={picture || ''}
      name={name}
      sx={{ ...sx, clipPath: mask ? clipPath : undefined }}
      BadgeProps={{
        ...rest,
        badgeContent: status && (
          <BadgeContainer>
            <BadgeStatus status={status} />
          </BadgeContainer>
        ),
      }}
    />
  );
};
